import { useCallback } from 'react';

import { useSpotlightContext } from './SpotlightContext';

export default function useSpotlightTarget(id) {
  const { register, unregister } = useSpotlightContext();

  return useCallback(
    node => {
      if (!id) return;
      if (node) register(id, node);
      else unregister(id);
    },
    [id, register, unregister],
  );
}
